import React from 'react';
import PropTypes from 'prop-types';
import Datetime from 'react-datetime';
import moment from 'moment';
import { FRONT_MF } from '../../CONST';


const MonthRangeFilter = ({ dispatch, datesFilter: { startDate, endDate }, changeDateActionName }) => (
  <>
    <div style={{ width: '180px' }}>
      <Datetime
        locale="es"
        renderInput={props => <input {...props} className="rs-input" />}
        dateFormat={FRONT_MF}
        timeFormat={false}
        value={startDate}
        onChange={newDate => {
          if (moment(newDate, FRONT_MF, true).isValid()) {
            dispatch({
              type: changeDateActionName,
              payload: {
                fieldName: 'startDate',
                value: newDate
              }
            });
          }
        }}
        isValidDate={date => moment(date).isSameOrBefore(endDate, 'days')}
        closeOnSelect
      />
    </div>
    <div className="orsan-label">Hasta:</div>
    <div style={{ width: '180px' }}>
      <Datetime
        locale="es"
        renderInput={props => <input {...props} className="rs-input" />}
        dateFormat={FRONT_MF}
        timeFormat={false}
        value={endDate}
        onChange={newDate => {
          if (moment(newDate, FRONT_MF, true).isValid()) {
            dispatch({
              type: changeDateActionName,
              payload: {
                fieldName: 'endDate',
                value: newDate
              }
            });
          }
        }}
        isValidDate={date => moment(date).isSameOrAfter(startDate, 'days')}
        closeOnSelect
      />
    </div>
  </>
);

MonthRangeFilter.propTypes = {
  dispatch: PropTypes.func.isRequired,
  datesFilter: PropTypes.shape({
    startDate: PropTypes.instanceOf(moment),
    endDate: PropTypes.instanceOf(moment),
  }).isRequired,
  changeDateActionName: PropTypes.string.isRequired,
};

export default MonthRangeFilter;
